import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '@aperza/ui';

export default class Price extends React.Component {

  static propTypes = {
    currency: PropTypes.string,
    price: PropTypes.any,
    openPrice: PropTypes.bool,
  };

  //http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  numberWithCommas(x) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  render() {

    let displayPrice = 'ASK';

    if (this.props.openPrice) {
      displayPrice = <Message messageId="price.openPrice" />
    } else {

      if (this.props.currency && this.props.price) {
        let currency = this.props.currency;
        let price = parseFloat(this.props.price);
        let rounding = 2;

        let symbol = '$';
        if (currency=='JPY') {
          symbol = '¥';
          rounding = 0;
        }

        let roundingMultiplier = Math.pow(10.0,rounding);
        let priceRounded = Math.round(price * roundingMultiplier) / roundingMultiplier;

        displayPrice = `${symbol}${this.numberWithCommas(priceRounded)}`;
        if (isNaN(priceRounded)) {
          displayPrice = '\u00a0';
        }
      }

    }

    return (
      <span>{displayPrice}</span>
    )
  }

}
